import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirXmark } from '@ng-icons/iconoir';
import { ShortcutsService } from '../../../../services/shortcuts.service';

/**
 * Aide des raccourcis clavier (touche `?`, MOKA-349) : petite fenêtre listant ce que le clavier
 * sait faire. Monté une seule fois dans `app.component`. Échap la ferme (géré par `app.component`),
 * le focus est piégé dedans et rendu au déclencheur à la fermeture.
 */
@Component({
  selector: 'app-shortcuts-help',
  imports: [A11yModule, NgIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideIcons({ iconoirXmark })],
  templateUrl: './shortcuts-help.component.html',
  styleUrl: './shortcuts-help.component.scss',
})
export class ShortcutsHelpComponent {
  protected readonly shortcuts = inject(ShortcutsService);

  /** ⌘ sur Mac, Ctrl ailleurs. */
  private readonly isMac = typeof navigator !== 'undefined' && /mac|iphone|ipad/i.test(navigator.platform || navigator.userAgent);

  protected readonly rows = computed(() =>
    this.shortcuts.shortcuts().map(s => ({
      label: s.label,
      keys: s.keys.map(k => (k === 'Ctrl' && this.isMac ? '⌘' : k)),
    }))
  );
}
